import { render, staticRenderFns } from "./BtnCreateModel.vue?vue&type=template&id=566beee6&"
import script from "./BtnCreateModel.vue?vue&type=script&lang=js&"
export * from "./BtnCreateModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports